import { createRoot } from 'react-dom/client';
import { AuthProvider } from './lib/auth.jsx';
import { UIProvider } from './lib/ui.jsx';
import App from './App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <UIProvider>
      <App />
    </UIProvider>
  </AuthProvider>
);

// PWA service worker — อ่านออฟไลน์ได้ แต่ห้าม queue การเขียน (ดู public/sw.js)
if ('serviceWorker' in navigator && location.hostname !== 'localhost') {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}
